import { appApis } from "../constants";
import reduxKeys from "../constants/reduxKeys";
import HttpClient from "./http-client";

export const getInstallers = (filter) => {
    return new HttpClient().get(`${appApis.getInstallers}${filter ? `?status=${String(filter).toLowerCase()}` : ""}`);
}

export const addInstallers = (payload) => {
    return new HttpClient().post(appApis.getInstallers, payload);
}

export const setIntsallerList = () => {
    return (dispatch) =>{
        getInstallers().then(response => {
            dispatch({ type: reduxKeys.SET_INSTALLERS, payload: response?.data?.data?.installers ?? []})
        }).catch(ex => {})
    }
}

export const getUserRoles = () =>{
    return (dispatch) => {
        new HttpClient().get(appApis.getUserRoles).then(response => {
            if(response?.data){
                dispatch({ type: reduxKeys.SET_USERS_ROLES, payload: response?.data?.data || [] });
            }
        }).catch(ex => {

        })
    }
}